export default "__VITE_ASSET__B7HPja90__"